<app-modal-notify #crearModal></app-modal-notify> 

<div class="ms-CommandBar ms-CommandBar--navBar">
  <div class="ms-CommandBar-center">
  </div>
  <div class="ms-CommandBar-sideCommands">
    <div class="ms-CommandButton ms-CommandButton">
      <button class="ms-CommandButton-button" (click)="abrirModalGuardarFormulario()">
        <span class="ms-CommandButton-icon ms-fontColor-themePrimary">
          <i class="ms-Icon ms-Icon--Save"></i>
        </span>
        <span class="ms-CommandButton-label">Guardar</span>
      </button>
    </div>
  </div>
</div>
<h2 class="nombreFormulario">{{nombreFormulario}}</h2>


<!-- Nuevo -->
<!-- <div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader create-formulario">
    <div class="ms-Dialog-title">Crear Nuevo Proceso</div>
    <form>
      <div class="ms-Dialog-content input-grid">
        <div class="input-group">
          <label class="ms-Label is-required">Nombre</label>
          <input
            class="ms-TextField-field text-Create"
            type="text"
            placeholder="Nombre"
            [(ngModel)]="formularioObj.Nombre"
            name="Nombre"
            required
          />
          <div *ngIf="invalidField('Nombre')">
            <label class="ms-Label is-required">Nombre es requerido</label>
          </div>
        </div>
        <div class="input-group">
          <label class="ms-Label is-required">Descripcion</label>
          <input
            class="ms-TextField-field text-Create"
            type="text"
            placeholder="Descripcion"
            [(ngModel)]="formularioObj.Descripcion"
            name="Descripcion"
            required
          />
          <div *ngIf="invalidField('Descripcion')">
            <label class="ms-Label is-required"
              >Descripcion de Proceso es requerido</label
            >
          </div>
        </div>
        <div class="input-group">
          <div class="ms-Dropdown dropdown-edit" tabindex="0">
            <label class="ms-Label is-required">Estado</label>
            <i class="ms-Dropdown-caretDown ms-Icon ms-Icon--ChevronDown"></i>
            <select
              class="ms-Dropdown-select dropdown-id-edit"
              [(ngModel)]="formularioObj.Estado"
              name="Estado"
            >
              <option disabled>Seleccione</option>
              <option value="1">Diseño</option>
              <option value="2">Pruebas</option>
              <option value="3">Produccion</option>
            </select>
          </div>
          <div *ngIf="invalidField('Estado')">
            <label class="ms-Label is-required">Estado es requerido</label>
          </div>
        </div>

        <div class="input-group">
          <label class="ms-Label is-required">Version</label>
          <input
            class="ms-TextField-field text-Create"
            type="number"
            [(ngModel)]="formularioObj.Version"
            name="Version"
            required
          />
          <div *ngIf="invalidField('Version')">
            <label class="ms-Label is-required">Version es requerido</label>
          </div>
        </div>
        <div class="input-group">
          <label class="ms-Label is-required">Todos Usuarios</label>
          <input
            class="ms-TextField-field ng-pristine ng-valid ms-DatePicker-input ng-touched"
            type="checkbox"
            [(ngModel)]="formularioObj.TodosUsuarios"
            name="TodosUsuarios"
          />
        </div>
        <div class="input-group">
          <label class="ms-Label is-required">Activo</label>
          <input
            class="ms-TextField-field ng-pristine ng-valid ms-DatePicker-input ng-touched"
            type="checkbox"
            [(ngModel)]="formularioObj.Activo"
            name="Activo"
          />
        </div>
      </div>
      <div class="ms-Dialog-actions" [hidden]="botonProcesando">
        <button
          type="button"
          class="ms-Button ms-Dialog-action"
          (click)="clearFormFormulario()"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="ms-Button ms-Button--primary"
          (click)="crearFormulario()"
        >
          <span class="ms-Button-label">Crear</span>
        </button>
      </div>
    </form>

    <div class="ms-Spinner" [hidden]="!botonProcesando">
      <div class="ms-Spinner-label">
        {{ textoBotonProcesando }}
      </div>
    </div>
  </div>
</div> -->


  <!-- Modal -->
  <div class="docs-DialogExample-lgHeader success">
    <div class="ms-Dialog ms-Dialog--lgHeader guardar-formulario">
      <div class="ms-Dialog-title">Guardar Formulario</div>
      <div class="ms-Dialog-content">
        <p class="ms-Dialog-subText">¿Desea guardar el formulario?</p>
      </div>
      <div class="ms-Dialog-actions">
        <button
          class="ms-Button ms-Dialog-action ms-Button--primary"
          (click)="actualizarFormulario()"
        >
          <span class="ms-Button-label">Aceptar</span>
        </button>
      </div>
    </div>
  </div>



<!-- Modal -->
<div class="docs-DialogExample-lgHeader editado">
  <div class="ms-Dialog ms-Dialog--lgHeader editar-formulario">
    <div class="ms-Dialog-title">Formulario Almacenado Correctamente</div>
    <div class="ms-Dialog-content">
      <p class="ms-Dialog-subText">Se ha almacenado el Formulario.</p>
    </div>
    <div class="ms-Dialog-actions">
      <button
        class="ms-Button ms-Dialog-action ms-Button--primary"
        (click)="abrirDatatable()"
      >
        <span class="ms-Button-label">Aceptar</span>
      </button>
    </div>
  </div>
</div>

<div id="form"></div>
